import BannerBg from '@/public/assets/images/runes/runes-contest-bg.png'
import BannerBgMobile from '@/public/assets/images/runes/runes-contest-bg-mobile.png'
import { Image as ImageHoc } from '@/components/HOC/Image'
import { RulesButton } from '@/components/atoms/RulesButton/RulesButton'
import { GameRules } from 'types/types'
import { Flex, Icon, Skeleton, Text } from '@chakra-ui/react'
import TicketIcon from '@/public/assets/icons/ticket.svg'
import { GET_PLINKO_TICKETS_BY_USER } from '@/api/query'
import { useSession } from '@/context/SessionProvider'
import { useQuery as useApolloQuery } from '@apollo/client'
import { useRouter } from 'next/router'

export const PlinkoBanner = () => {
  const router = useRouter()

  return (
    <Flex
      onClick={() => router.push('/plinko/leaderboard')}
      mb={6}
      overflow={'hidden'}
      pos={'relative'}
      py={{ base: 2.5, md: 4 }}
      px={{ base: 2, md: 0 }}
      alignItems={'center'}
      justifyContent={'center'}
      rounded={'xl'}
      cursor={'pointer'}
    >
      <Flex
        alignItems={'center'}
        gap={{ base: 1.5, md: 4 }}
        pos={'relative'}
        zIndex={10}
        flexWrap={{ base: 'wrap', md: 'nowrap' }}
        justifyContent={'center'}
        w={'full'}
      >
        <Text
          fontSize={{ base: 'sm', md: '26px' }}
          fontWeight={700}
          whiteSpace={{ base: 'normal', md: 'nowrap' }}
          textAlign={{ base: 'center', md: 'left' }}
          lineHeight={{ base: '1.2', md: 'normal' }}
        >
          Farm balls and {'  '}
          <Text
            display={'inline-block'}
            as={'span'}
            bg={'#7A4EF8'}
            bgBlendMode={'overlay'}
            bgGradient={`linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.5) 33%, rgba(255, 255, 255, 0.25) 66%, rgba(255, 255, 255, 0.25) 75%, rgba(255, 255, 255, 0.25) 100%)`}
            backgroundClip={'text'}
            __css={{
              '-webkit-text-fill-color': 'transparent',
            }}
          >
            win 500$
          </Text>
        </Text>
        <Flex gap={{ base: 1.5, md: 4 }} alignItems={'center'}>
          <TicketsCounter />
          <RulesButton
            compact={true}
            styles={{
              height: { base: '28px', md: '40px' },
              borderRadius: { base: 'lg', md: 'xl' },
              borderWidth: '2px',
              borderColor: 'rgba(255, 255, 255, 0.4)',
              px: { base: 2, md: 4 },
            }}
            game={GameRules.RUNES_COMPETITION}
          />
        </Flex>
      </Flex>
      <ImageHoc
        display={{ base: 'none', md: 'block' }}
        pos={'absolute'}
        w={'full'}
        h={'full'}
        inset={0}
        objectFit={'cover'}
        src={BannerBg}
        alt={''}
      />
      <ImageHoc
        display={{ base: 'block', md: 'none' }}
        pos={'absolute'}
        w={'full'}
        h={'full'}
        inset={0}
        objectFit={'cover'}
        src={BannerBgMobile}
        alt={''}
      />
    </Flex>
  )
}

const TicketsCounter = () => {
  const { account } = useSession()
  const router = useRouter()

  const { data, loading, error } = useApolloQuery(GET_PLINKO_TICKETS_BY_USER, {
    variables: { address: account?.injectiveAddress || '' },
    skip: !account?.injectiveAddress,
  })

  if (!account?.injectiveAddress) {
    return null
  }

  if (loading || error) {
    return (
      <Skeleton
        startColor="ninja.300"
        endColor="ninja.200"
        height={{ base: '28px', md: '40px' }}
        width={{ base: '60px', md: '160px' }}
        borderRadius={'lg'}
      />
    )
  }

  return (
    <Flex
      onClick={() => router.push('/plinko/leaderboard')}
      flexShrink={0}
      px={{ base: 2, md: 3 }}
      py={{ base: 1, md: 2.5 }}
      cursor={'pointer'}
      bg={'rgba(255, 255, 255, 0.01)'}
      _hover={{ bg: 'rgba(255, 255, 255, 0.1)' }}
      boxShadow={`0 -2px 12px 0 #FFF inset;`}
      rounded={{ base: 'lg', md: 'xl' }}
      alignItems={'center'}
      fontWeight={700}
      transition={'0.2s'}
      fontSize={'sm'}
      userSelect={'none'}
      lineHeight={'16px'}
      gap={2}
    >
      <Icon as={TicketIcon} boxSize={5} />
      <Text>{data?.userCompetition?.score.toLocaleString('en-US')}</Text>
      {data?.userCompetition?.score > 100 ? null : (
        <Text color={'ninja.100'} display={{ base: 'none', md: 'block' }}>
          Your Tickets
        </Text>
      )}
    </Flex>
  )
}
